import React, { useState, useContext, useEffect } from 'react';

import { Links } from '@/utils/constants';

import logoImage from '@/images/Header/logo-image.svg';
import logoText from '@/images/Header/logo-text.svg';
import logoTextMobile from '@/images/Header/logo-text-mobile.svg';
import { MENU_LIST_ITEMS } from './components/MenuListItem/constants';

import {
  HeaderBox,
  FlexContainer,
  Logo,
  LogoScroll,
  LogoImage,
  LogoText,
  LogoTextMobile,
  MenuBox,
  MenuList,
  ButtonBox,
  MobileButtonBox,
  BurgerBox,
  Burger,
  BurgerOverlay,
} from './Header.styled';
import { MenuListItem } from './components';
import Container from '../Container';
import { FixedContext } from '../Wrapper';
import { Button, ButtonColors } from '../general';

interface IHeader {
  currentpath?: Links | string;
  error?: boolean;
}

export const Header: React.FC<IHeader> = ({ currentpath, error }) => {
  const [burger, setBurger] = useState<boolean>(false);
  const [shadow, setShadow] = useState<boolean>(false);
  const [zIndex, setZIndex] = useState<boolean>(false);

  useEffect(() => {
    if (burger) {
      document.body.classList.add('lock');
    } else {
      document.body.classList.remove('lock');
    }
  }, [burger]);

  const tagsFixed = useContext(FixedContext);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const burgerClick = () => {
    setBurger(!burger);
  };

  useEffect(() => {
    const manageShadow = () => {
      setShadow(window.scrollY > 0);
      setZIndex(window.scrollY > 0);
    };

    window.addEventListener('scroll', manageShadow);

    // return window.removeEventListener('scroll', manageShadow);
  }, []);

  return (
    <HeaderBox
      currentpath={currentpath}
      $burgerActive={burger}
      error={error}
      $shadow={shadow}
      $zIndex={zIndex}
    >
      <Container>
        <FlexContainer>
          {currentpath === Links.HOME ? (
            <LogoScroll onClick={scrollToTop}>
              <LogoImage src={logoImage} alt="logo image" />
              <LogoText src={logoText} alt="logo text" />
              <LogoTextMobile src={logoTextMobile} alt="logo text mobile" />
            </LogoScroll>
          ) : (
            <Logo to={Links.HOME} onClick={scrollToTop}>
              <LogoImage src={logoImage} alt="logo image" />
              <LogoText src={logoText} alt="logo text" />
              <LogoTextMobile src={logoTextMobile} alt="logo text mobile" />
            </Logo>
          )}
          {!error && (
            <>
              <MenuBox $active={burger}>
                <MenuList $active={burger} $isVisible={!tagsFixed.isFixed}>
                  {MENU_LIST_ITEMS.map((item, index) => (
                    <MenuListItem
                      key={item.name}
                      item={item}
                      $isFixed={tagsFixed.isFixed}
                      $fixedTime={(index + 1) / 4}
                      setBurger={setBurger}
                      burger={burger}
                      currentpath={currentpath}
                      setZIndex={setZIndex}
                    />
                  ))}
                </MenuList>
                <MobileButtonBox>
                  {currentpath !== Links.PRICING && (
                    <Button to={Links.PRICING} height={36}>
                      Start Building
                    </Button>
                  )}
                  {currentpath !== Links.REQUEST && (
                    <Button
                      color={ButtonColors.SECONDARY}
                      to={Links.REQUEST}
                      height={36}
                      style={{
                        marginRight: currentpath !== Links.PRICING && '15px',
                      }}
                    >
                      Request a demo
                    </Button>
                  )}
                </MobileButtonBox>
              </MenuBox>
              <ButtonBox>
                {currentpath !== Links.SIGN && (
                  <Button
                    color={ButtonColors.SECONDARY}
                    to={Links.SIGN}
                    height={36}
                    style={{
                      marginRight: currentpath !== Links.PRICING && '15px',
                    }}
                  >
                    Sign In
                  </Button>
                )}
                {currentpath !== Links.PRICING && (
                  <Button to={Links.PRICING} height={36}>
                    Get started
                  </Button>
                )}
              </ButtonBox>
              <BurgerBox onClick={burgerClick} $active={burger}>
                <Burger />
              </BurgerBox>
            </>
          )}
        </FlexContainer>
      </Container>
      <BurgerOverlay $active={burger} />
    </HeaderBox>
  );
};
